import { lazy, Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import 'aos/dist/aos.css';
import './index.css';

const Header = lazy(() => import('./components/Header'));
const Home = lazy(() => import('./pages/Home'));

function App() {
  useEffect(() => {
    (async () => {
      const AOS = await import('aos');
      AOS.init({ duration: 800, easing: 'ease-in-out', once: true });
    })();
  }, []);

  return (
    <>
      <Suspense fallback={null}>
        <Header />
      </Suspense>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </Suspense>
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: '#111720',
            color: '#e7ecef',
            border: '1px solid #232b3a',
            borderRadius: '12px',
            fontFamily: 'Inter, sans-serif',
            fontSize: '0.875rem',
          },
        }}
      />
    </>
  );
}

export default App;
